import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { testEquipmentsApiRef, TestEquipmentsClient } from './api';
import { rootRouteRef } from './routes';

export const testEquipmentsPlugin = createPlugin({
  id: 'test-equipments',
  routes: { root: rootRouteRef },
  apis: [
    createApiFactory({
      api: testEquipmentsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new TestEquipmentsClient(discoveryApi, fetchApi),
    }),
  ],
});

export const TestEquipmentsPage = testEquipmentsPlugin.provide(
  createRoutableExtension({
    name: 'TestEquipmentsPage',
    component: () =>
      import('./components/TestEquipmentsPage').then(m => m.TestEquipmentsPage),
    mountPoint: rootRouteRef,
  }),
);
